import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';

export const APP_VERSION = new InjectionToken<string>('APP_VERSION');

export function provideAppVersion(version: string): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: APP_VERSION,
      useValue: version,
    },
  ]);
}
